import { createSelector } from 'reselect';

const slice = (state) => (state && state.planCatalog) || {};

export const planCatalogOverviewSelector = createSelector(
  slice,
  (s) => s.overview || null
);

export const planCatalogLoadingSelector = createSelector(
  slice,
  (s) => !!s.loading
);

export const planCatalogPreviewSelector = createSelector(
  slice,
  (s) => s.preview || null
);
